import type { QuizAnswers } from '@sifly/quiz-engine'

// PDP links from the quiz results carry ?rec=quiz so the product page can show a
// dismissible "Recommended from your quiz answers" chip. The chip reads the param
// client-side so the PDP's server render never depends on it. See QuizRecChip.
export const REC_QUERY = '?rec=quiz'

/**
 * Show the try-before-you-buy rental bridge only when the dealer actually has a
 * rentals path AND the rider self-identified as new to the sport.
 *
 * `confidence: 'unsure'` ("New to this, a bit unsure of my balance") is the
 * shipped quiz-engine's equivalent of the audit's "Never tried" answer — the old
 * dead quiz had a literal "Never tried" option; the real scoring quiz uses
 * confidence bands. Pure + standalone (no next/link, no react) so the intent is
 * unit-tested directly (autoplan eng-review H3).
 */
export function shouldShowRentalBridge(
  answers: Partial<QuizAnswers>,
  rentalsHref: string | null | undefined,
): rentalsHref is string {
  return !!rentalsHref && answers.confidence === 'unsure'
}
